import { Pipe, type PipeTransform } from '@angular/core';

@Pipe({
  name: 'autopayHistory',
  standalone: true,
})
export class AutopayHistoryPipe implements PipeTransform {
  transform(value: any, isAutopay: boolean): unknown {
    if (isAutopay) {
      return 'Pending';
    } else {
      return value;
    }
  }
}
